// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image__wrap[data-v-acf6ee4a]{text-align:center}.image__wrap[data-v-acf6ee4a],img[data-v-acf6ee4a]{width:100%;height:100%}img[data-v-acf6ee4a]{max-width:100%;max-height:100%;object-fit:cover}@media only screen and (max-width:1024px){img[data-v-acf6ee4a]{object-fit:contain}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
